import { render, staticRenderFns } from "./VoiceSetting.vue?vue&type=template&id=6c71b35d&scoped=true&"
import script from "./VoiceSetting.vue?vue&type=script&lang=js&"
export * from "./VoiceSetting.vue?vue&type=script&lang=js&"
import style0 from "./VoiceSetting.vue?vue&type=style&index=0&id=6c71b35d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c71b35d",
  null
  
)

export default component.exports